import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoGrandi10Sedan2023 from "../grandi10sedan2023/InfoGrandi10Sedan2023";
const Footer = lazy(() => import('../footer/Footer'));
function Grandi10Sedan2023() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="El Grand i10 Sedán es cómodo, espacioso y cuenta con un diseño avanzado y refinado. Cargado de estilo, calidad, espacio, confort y seguridad"
        />
        <meta
          name="keywords"
          content="Automóvil, Sedán, Hyundai, Hyundai Grand i10, Grand i10 Sedán, i10, mejor sedán"
        />
        <title>Hyundai Grand i10 Sedán</title>
      </Helmet>
      <Menu />
      <InfoGrandi10Sedan2023 />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Grandi10Sedan2023;